module.exports = __webpack_public_path__ + "img/detailed-data-view.94293604.png";